class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    // Observer to clean up any undefined text injected by third-party scripts
    this.setupCleanupObserver();
  }

  setupCleanupObserver() {
    const cartNotification = document.getElementById('cart-notification');
    if (!cartNotification) return;

    const cleanUndefined = (element) => {
      element.childNodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('undefined')) {
          node.textContent = '';
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          cleanUndefined(node);
        }
      });
    };

    const observer = new MutationObserver(() => cleanUndefined(cartNotification));
    observer.observe(cartNotification, { childList: true, characterData: true, subtree: true });
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        const targetElement = document.getElementById(section.id);
        const sectionHtml = parsedState.sections ? parsedState.sections[section.id] : null;
        if (targetElement && sectionHtml) {
          const content = this.getSectionInnerHTML(sectionHtml, section.selector);
          if (content && !content.includes('undefined')) {
            targetElement.innerHTML = content;
          }
        }
      }));

      // Clear any undefined text from cart notification
      const linksContainer = this.notification.querySelector('.cart-notification__links');
      if (linksContainer) {
        const cleanUndefined = (element) => {
          element.childNodes.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('undefined')) {
              node.textContent = '';
            } else if (node.nodeType === Node.ELEMENT_NODE) {
              cleanUndefined(node);
            }
          });
        };
        cleanUndefined(linksContainer);
      }

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const element = doc.querySelector(selector);
    return element ? element.innerHTML : '';
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
